

<template>

  <footer id="footer" class="shadow-xs">
    <div class="container">
      <div class="row gutters-lg">
        <!-- col 1 : contact -->
        <div class="order-3 order-lg-1 col">
          <div class="pt-5 px-3 text-center">
            <h4>{{ $t('footerContacts') }}</h4>
            <div class="mb-4">
              <ul class="list-unstyled mb-0 mt-5 px-3">
                <li class="list-item py-2">
                  <a :href="'tel:' + $t('contactsMainPhoneLink')" class="clearfix py-1 h5 mb-0 d-block font-weight-medium">
                    <i class="fi fi-phone mr-3"></i>
                    <span>{{ $t('contactsMainPhone') }}</span>
                  </a>
                </li>

                <li class="list-item py-2">
                  <a :href="'mailto:tybesty@abv.bg'" class="clearfix py-1 h6 d-block font-weight-medium">
                    <span>tybesty@abv.bg</span>
                  </a>
                </li>
              </ul>

              <!-- social -->
              <!-- <div class="clearfix">
                <a href="#!" class="btn btn-sm btn-facebook transition-hover-top mb-2 rounded-circle text-white" rel="noopener" aria-label="facebook page">
                  <i class="fi fi-social-facebook"></i>
                </a>
                <a href="#!" class="btn btn-sm btn-twitter transition-hover-top mb-2 rounded-circle text-white" rel="noopener" aria-label="twitter page">
                  <i class="fi fi-social-twitter"></i>
                </a>
                <a href="#!" class="btn btn-sm btn-linkedin transition-hover-top mb-2 rounded-circle text-white" rel="noopener" aria-label="linkedin page">
                  <i class="fi fi-social-linkedin"></i>
                </a>
                <a href="#!" class="btn btn-sm btn-youtube transition-hover-top mb-2 rounded-circle text-white" rel="noopener" aria-label="youtube page">
                  <i class="fi fi-social-youtube"></i>
                </a>
              </div> -->
              <!-- /social -->
            </div>
          </div>
        </div>

        <!-- MIDDLE : LOGO -->
        <div class="order-2 col-12 col-lg-4 col-xl-4 mt--n30 m-0-xs m-0-md bg-gradient-dark rounded-top d-flex flex-wrap align-items-center justify-content-center">
          <div class="px-4 pt-5 pb-4 text-center">
            <!-- svg icon -->
            <div class="py-3">
              <svg width="100" height="100" viewBox="0 0 512 512" fill="#ffffff">
                <path d="M485.045 84.997c-21.364-28.044-52.4-46.114-87.392-50.882-5.227-.712-10.433-1.073-15.474-1.073-20.222 0-39.232 5.67-58.116 17.333-21.101 13.032-40.502 32.378-61.022 52.841l-41.329 41.508c-14.991 15.012-14.991 39.438 0 54.45l5.065 5.072c7.243 7.254 16.965 11.701 27.215 11.847 10.469.148 20.338-3.856 27.782-11.286l24.908-24.535c1.813-1.785 3.421-4.895 26.408-27.798l109.88 108.883 66.493-76.001c.708-.77 1.157-1.724 1.298-2.758 4.779-34.895-4.354-69.556-25.716-97.601zM258.203 365.01c-7.268-7.279-16.934-11.288-27.217-11.288s-19.948 4.009-27.217 11.288l-.701.702c13.402-15.102 12.884-38.313-1.564-52.782-7.268-7.279-16.934-11.288-27.216-11.288-7.642 0-14.941 2.218-21.171 6.344 10.665-15.026 9.286-36.053-4.157-49.514-7.268-7.279-16.934-11.288-27.216-11.288s-19.948 4.009-27.217 11.288l-41.413 41.473c-14.99 15.012-14.99 39.439 0 54.451 7.268 7.28 16.934 11.289 27.216 11.289 7.642 0 14.941-2.218 21.171-6.344-10.665 15.025-9.286 36.052 4.156 49.513 7.268 7.279 16.934 11.288 27.216 11.288s19.948-4.009 27.217-11.288l.706-.707c-13.408 15.101-12.892 38.316 1.558 52.787 7.268 7.279 16.934 11.288 27.216 11.288s19.948-4.009 27.216-11.288l41.413-41.474c14.995-15.011 14.995-39.438.004-54.45zM296.273 412.813c-3.189 10.192-8.792 19.785-16.843 27.846l-20.565 20.596 8.802 8.802c11.84 11.841 31.027 11.871 42.905.068 11.957-11.882 11.956-31.227-.002-43.108zM333.747 195.378l-30.86 30.741c-12.947 12.883-30.107 19.978-48.333 19.978l-.988-.007c-17.924-.254-34.978-7.586-48.018-20.646l-5.064-5.072c-26.662-26.701-26.662-70.146 0-96.846l39.585-39.756c-31.451-28.733-67.978-53.085-116.864-46.419-37.703 5.136-71.143 24.606-94.16 54.822-23.019 30.217-32.859 67.563-27.708 105.16.52 3.798 2.45 7.263 5.407 9.712l51.866 42.94 13.691-13.711c13.617-13.637 31.963-20.825 51.342-20.031 14.837.608 29.174 6.079 40.617 15.543 1.905 1.575 3.687 3.235 5.373 4.955l.558.532c.232.233.433.471.634.708 9.395 10.076 15.175 22.32 17.355 35.071 13.005 2.667 24.956 9.067 34.555 18.68 9.091 9.104 15.063 20.159 17.953 31.83.191-.254 2.033.289 4.602 1.66 12.845 2.717 24.646 9.079 34.142 18.591 8.186 8.197 13.848 17.976 17.007 28.361l36.124 34.536c11.479 10.975 29.531 11.103 41.16.286 1.081-1.006 1.992-1.879 2.666-2.554l.497-.511c9.994-10.538 9.576-27.196-.694-37.465l-83.018-83.015c-5.99-5.99-5.976-15.689.031-21.662 6.008-5.973 15.734-5.96 21.724.031l80.485 80.49c11.84 11.841 31.027 11.871 42.905.068 11.957-11.882 11.956-31.227-.003-43.108z"></path>
              </svg>
            </div>

            <!-- logo -->
            <div class="py-3">
              <img height="40" src="@/assets/images/logo.png" alt="...">
            </div>

            <!-- copyright -->
            <p class="fs--14">
              <span>&copy; {{ $t('footerAllRightsReserved') }}</span>
              <br>
              <span>{{ $t('footerDevelopedBy') }} <a href="https://www.linkedin.com/in/atanas-arshinkov/" target="_blank" style="color: white; text-decoration: underline;">{{ $t('footerAuthor') }}</a></span>
              <br>
              <span>v1.0.11</span>
            </p>
          </div>
        </div>

        <!-- col 2 : Opening -->
        <div class="order-1 order-lg-3 col">
          <div class="py-5">
            <div class="col-12">

              <h4 class="text-center">{{ $t('information') }}</h4>
              <div class="row">
                <div class="col-12">

                  <ul class="mt-4 mb-0 list-unstyled p-0 block-xs">
                    <li>
                      <i class="fi fi-home mr-2"></i>
                      <router-link to="/">{{ $t('menuHome') }}</router-link>
                    </li>
                    <li>
                      <i class="fi fi-list-checked mr-2"></i>
                      <router-link to="/products">{{ $t('menuProducts') }}</router-link>
                    </li>
                    <li>
                      <i class="fi fi-support-headphones mr-2"></i>
                      <router-link to="/contacts">{{ $t('menuContacts') }}</router-link>
                    </li>
                    <li>
                      <i class="fi fi-folder-full mr-2"></i>
                      <router-link to="/terms-and-conditions">{{ $t('menuTermsAndConditions') }}</router-link>
                    </li>
                    <li>
                      <i class="fi fi-shield-ok mr-2"></i>
                      <router-link to="/privacy-policy">{{ $t('menuPrivacyPolicy') }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-12">

                  <ul class="mt-4 mb-0 list-unstyled p-0 block-xs">
                    <li>
                      <router-link to="/products/blinds">{{ $t('menuProductsBlinds') }}</router-link>
                    </li>
                    <li>
                      <router-link to="/products/air-conditions">{{ $t('menuProductsAirConditions') }}</router-link>
                    </li>
                    <li>
                      <router-link to="/products/infrared-panels">{{ $t('menuProductsInfraredPanelsShort') }}</router-link>
                    </li>
                    <li>
                      <router-link to="/products/thermo-paints">{{ $t('menuProductsThermoPaintsShort') }}</router-link>
                    </li>
                    <li>
                      <router-link to="/products/windows">{{ $t('menuProductsWindows') }}</router-link>
                    </li>
                    <li>
                      <router-link to="/products/nets">{{ $t('menuProductsNets') }}</router-link>
                    </li>
                    <li>
                      <router-link to="/products/doors">{{ $t('menuProductsDoors') }}</router-link>
                    </li>
                  </ul>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
export default {
  name: "Footer",
};
</script>
